export default __webpack_public_path__ + "static/aryan _jalan _seo consultant-6672b93933e779cc4e4df7666fae24f2.png";